import React, { Component } from 'react';
import { makeStyles } from '@mui/styles';
import {Paper, Tabs, Tab, Typography, Box, Grid, Container} from '@mui/material';
import FollowUpHarian from './FollowUpHarian';
import { Link } from 'react-router-dom';
import FollowUpRutin from './FollowUpRutin';
import FollowUpReport from './FollowUpReport';
import Global from "../../customlib/Global";
import DataPendingEffectivityRate from './DataPendingEffectivityRate';
import DataPendingLeads from './DataPendingLeads';
import DataCancelDashboard from './DataCancelDashboard';
import ReportLeadsDataCancel from './RportLeadsDataCancel';
import ReportPerformaDataCancel from './ReportPerformaDataCancel';
import ReportPerformaDataCancelNew from './ReportPerformaDataCancelNew';
import WhyAnalysisDataCancel from './WhyAnalysisDataCancel';
import ReviewSavedAnalysis from './WhyAnalysisDataCancel/ReviewSavedAnalysis';

function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
      <div
        role="tabpanel"
        hidden={value !== index}
        id={`full-width-tabpanel-${index}`}
        aria-labelledby={`full-width-tab-${index}`}
        {...other}
      >
        {value === index && (
          <Box p={3}>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }

class AnalisaDataCancel extends Component {

    state = { 
        value : 0,
    }

    useStyles = makeStyles({
        root: {
          flexGrow: 1,
        },
      });

    // classes = useStyles();
    // const [value, setValue] = React.useState(0);

    componentDidMount() {
        this.setState({value: 0});
    }
    

    handleChange = (event, newValue) => {
        // setValue(newValue);
        this.setState({value:newValue});
    };

    render() { 
        return ( 
            <>
            <Paper elevation={0} className={this.useStyles.root}>
                <Box sx={{pl: "30px", pr: "30px", pt: "20px"}}>
                  <Grid container spacing={1}>
                      <Grid item xs={11}>
                        {
                          !this.props.isMobile && (<h1>Analisa Data Cancel</h1>)
                        }
                        {
                          this.props.isMobile && (<Box sx={{fontSize: "23px"}}>Analisa Data Cancel</Box>)
                        }
                      </Grid>
                      <Grid item xs={1} textAlign={"right"}>
                        {
                          !this.props.isMobile && (
                            <Link to="/">
                                <div className="btn btn-danger">X</div>
                            </Link>
                          )
                        }

                        {
                          this.props.isMobile && (
                            <div className="btn btn-danger" onClick={this.props.onClose}>X</div>
                          )
                        }
                      </Grid>
                  </Grid>
                </Box>
                <Tabs
                    value={this.state.value}
                    onChange={this.handleChange}
                    indicatorColor="secondary"
                    textColor="primary"
                    centered
                >
                    <Tab key="tab0" label="Dashboard TL" wrapped/>
                    <Tab key="tab1" label="Dashboard SPV" wrapped/>
                    <Tab key="tab2" label="Report Performa" wrapped/>
                    {/* <Tab key="tab3" label="Input Analisa" />
                    <Tab key="tab4" label="Report Leads" /> */}
                </Tabs>
            </Paper>
            <TabPanel value={this.state.value} index={0}>
                <WhyAnalysisDataCancel {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={1}>
                <ReviewSavedAnalysis {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={2}>
                <ReportPerformaDataCancelNew />
            </TabPanel>
            <TabPanel value={this.state.value} index={3}>
                <DataCancelDashboard {...this.props} />
            </TabPanel>
            <TabPanel value={this.state.value} index={4}>
                <ReportLeadsDataCancel {...this.props} />
            </TabPanel>
            </>
         );
    }
}
 
export default AnalisaDataCancel;